// Default for settings.auto_new_product_addition when a campaign has never set
// it. Mirrors the backend (pricerest util/auto_import_util.py): on for regular
// campaigns, off for campaigns fed by a marketplace API or a Shopify store,
// whose catalog is the merchant's whole store -- an admin turns it on there.
export const isStoreCampaign = (settings) => !!(settings && (settings.marketplace_api || settings.shopify_oauth));

export const autoNewProductAdditionDefault = (settings) => !isStoreCampaign(settings);
